import React, { Component } from 'react';
import Firebase from 'firebase'

import img1 from '../assets/images/staff-1.jpg';
import img2 from '../assets/images/staff-2.jpg';

class SectionTeam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTeam: []
    }
  }

  componentDidMount() {
    Firebase.database().ref('team').on('value', data => {
      this.setState({dataTeam: data.val()})
    })
  }

  render() { 
    let {dataTeam} = this.state
    let elTeam = []

    if (dataTeam.length != 0) {
      let delaySection = 100
      dataTeam.forEach((element, index) => {
        elTeam[index] = <div className="col-sm-6 col-md-6 col-lg-3" data-aos="fade-up" data-aos-delay={delaySection} key={index}>
          <div className="staff">
            <div className="img-wrap d-flex align-items-stretch justify-content-end">
              <div className="img align-self-stretch" style={{backgroundImage: `url(${element.image})`}}></div>
            </div>
            <div className="text d-flex align-items-center pt-3">
              <div>
                <h3 className="mb-2">{element.firstname} <br/>{element.lastname}</h3>
                <span className="position mb-4">{element.jobtitle}</span>
                <ul className="ftco-social">
                  {
                    element.twitter ? 
                    <li data-aos="fade-up" data-aos-offset="-100" data-aos-delay={delaySection+=50}><a href={ element.twitter } target="_blank"><span className="icon-twitter"></span></a></li>
                    : ''
                  }
                  {
                    element.facebook ? 
                    <li data-aos="fade-up" data-aos-offset="-100" data-aos-delay={delaySection+=50}><a href={ element.facebook } target="_blank"><span className="icon-facebook"></span></a></li>
                    : ''
                  }
                  {
                    element.instagram ? 
                    <li data-aos="fade-up" data-aos-offset="-100" data-aos-delay={delaySection+=50}><a href={ element.instagram } target="_blank"><span className="icon-instagram"></span></a></li>
                    : ''
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
      });
    }

    return (
      <section className="ftco-section ftco-speakers" id="speakers-section">
        <div className="container">
          <div className="row justify-content-center pb-5">
            <div className="col-md-12 heading-section heading-section-white text-center" data-aos="fade-up">
              <span className="subheading">Teams</span>
              <h2 className="mb-4">Samawa Teams</h2>
              {/* <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia</p> */}
            </div>
          </div>
          <div className="row" style={{justifyContent: 'space-evenly'}}>
            {elTeam}
          </div>
        </div>
      </section>
    );
  }
}
 
export default SectionTeam;